var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/content/create_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/content/create_24px_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.369 3.29L20.709 5.63C21.099 6.02 21.099 6.65 20.709 7.04L18.879 8.87L15.129 5.12L16.959 3.29C17.149 3.1 17.399 3 17.659 3C17.919 3 18.169 3.09 18.369 3.29ZM2.99902 17.25V21H6.74902L17.809 9.94L14.059 6.19L2.99902 17.25ZM5.91902 19H4.99902V18.08L14.059 9.02L14.979 9.94L5.91902 19Z",
    fill: "#2771bb"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 24,
    height: 18
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/content/create_24px_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.369 3.29L20.709 5.63C21.099 6.02 21.099 6.65 20.709 7.04L18.879 8.87L15.129 5.12L16.959 3.29C17.149 3.1 17.399 3 17.659 3C17.919 3 18.169 3.09 18.369 3.29ZM2.99902 17.25V21H6.74902L17.809 9.94L14.059 6.19L2.99902 17.25ZM5.91902 19H4.99902V18.08L14.059 9.02L14.979 9.94L5.91902 19Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.f620e0af7ed2ebe02c92adb67b18f4ad.svg";
export { ForwardRef as ReactComponent };